import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=55d01850&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=ts"
export * from "./PaymentSettings.vue?vue&type=script&lang=ts"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=55d01850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d01850",
  null
  
)

export default component.exports